import {Service} from '../../../service';

export class InvoiceSynthesizeReportService extends Service {

  static entity = 'app/invoice-synthesize-report';

  static getList(params: any): Promise<any> {
    return this.axios.get(`${this.entity}`, {params}).then(res => res.data);
  }

  static getSummary(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/total-columns`, {params}).then(res => res.data);
  }

  static downloadExcel(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/file-excel`, {params, responseType: 'blob'}).then(res => res.data);
  }

  static downloadPdf(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/file-pdf`, {params, responseType: 'blob'}).then(res => res.data);
  }

}
